import { useTranslation } from "react-i18next";

import articlePublicationStatuses from "astrid-firestore/src/api/articles/constants/articlePublicationStatuses";
import getArticleChannelData from "astrid-firestore/src/api/articles/getArticleChannelData";

export default function usePublicationStatuses({ article, channel } = {}) {
	const { t } = useTranslation();

	return {
		[articlePublicationStatuses.PUBLISHED]: {
			color: "green",
			text: t("published", "Published"),
			date: getArticleChannelData(article, channel, "releaseDate"),
		},
		[articlePublicationStatuses.NOT_PUBLISHED]: {
			color: "grey",
			text: t("notPublished", "Not published"),
		},
		[articlePublicationStatuses.UNPUBLISHED]: {
			color: "red",
			text: t("unpublished", "Unpublished"),
			date: getArticleChannelData(article, channel, "takeDownDate"),
		},
		[articlePublicationStatuses.ANNOUNCED]: {
			color: "blue",
			text: t("announced", "Announced"),
			date: getArticleChannelData(article, channel, "announcementDate"),
		},
	};
}
